var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bbs-layout"},[_c('left'),_c('div',{staticClass:"content-layout"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }